import { createContext, useState, useContext, ReactNode } from 'react';
import { RenewalContextProps } from '../types/types';

interface RenewalProps {
  data: RenewalContextProps;
  setData: React.Dispatch<React.SetStateAction<RenewalContextProps>>;
}

const RenewalContext = createContext<RenewalProps | undefined>(undefined);

export const useRenewal = () => {
  const context = useContext(RenewalContext);
  if (!context) {
    throw new Error('useRenewal must be used within a RenewalProvider');
  }
  return context;
};

export const RenewalProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [data, setData] = useState<RenewalContextProps>({
    selectedOffer: {
      sku: '',
      saleType: '',
    },
    client: {
      cnpj: null,
    },
    requestInfo: {
      grupo: '',
      codRev: '',
      ar: '',
    },
  });

  return (
    <RenewalContext.Provider value={{ data, setData }}>
      {children}
    </RenewalContext.Provider>
  );
};
